module.exports = __webpack_public_path__ + "static/favicons/mstile-70x70-686b948a498b765bacdc5ab285d344b1.png";